import { useTranslation } from 'react-i18next'

import { Badge } from '~/components/common/Badge'

/**
 * 共通ポジションチャートの**入札種別 判別表示** (AC-BSP-016 [P0])。
 *
 * spec `docs/specs/bidding/spot-bidding.md`:
 * > ※ 通常入札タブとブロック入札タブでチャートを共通化する。 その際、 いま通常入札・
 * >   ブロック入札のどちらで入札しているかがチャート上で判別できるように表示する
 * >   （具体的なスタイルはデザイナー判断）
 *
 * チャートは**両タブの合算**を描く (`sharedPositionSlots`) ため、 約定(通常) と
 * 約定(ブロック) が同じ絵の中に並ぶ。 どちらを編集しているのかが絵からは読めないので、
 * 見出しで明示する。
 *
 * 文言はタブ名の i18n をそのまま引く。 **チップとタブ名が必ず一致する**ので、 対応が
 * 読み手の中で切れない。 `status="neutral"` は状態や重大度ではなく**分類**だから
 * (充足率バッジのような意味色を持たせると、 そちらと役割が混ざる)。
 *
 * [2026-09-02 / デザイナー判断] スタイルは spec がデザイナーに委ねている部分。 8080 にも
 * 実装にも判別表示は無く (8080 の `#chart-title-text` は「入札前/後のポジション」だけ)、
 * 新規に決めた。 #6596 でチャートをタブ外へ出す時は、 この `kind` を**表示中のタブから
 * 導出**する形に変える (出した先ではタブが判別の手掛かりにならないため、 この表示の
 * 重要度はむしろ上がる)。
 */
export const ChartBidKindBadge = ({
  kind,
}: {
  kind: 'normal' | 'block'
}): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Badge status="neutral">
      {kind === 'normal'
        ? t('page:biddingSpot.tab.normalBid')
        : t('page:biddingSpot.tab.blockBid')}
    </Badge>
  )
}
